/**
 * 二手车检测
 */
import { USED_CAR_MANAGE } from '../types';

export default {
    name: `${USED_CAR_MANAGE}`,
    path: '/usedCarVehicleManage',
    component: () => import(/* webpackChunkName: 'repairWorkOrder' */ '@/views/usedCar/usedCarVehicleManage/'),
    redirect: { name: `${USED_CAR_MANAGE}Index` },
    meta: {
        title: '二手车管理',
        savedPosition: { x: 0, y: 0 },
    },
    children: [
        {
            name: `${USED_CAR_MANAGE}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'repairWorkOrder' */ '@/views/usedCar/usedCarVehicleManage/home/Home.vue'),
        },
    ],
};
